import { createSelector } from '@reduxjs/toolkit';
import { selectInstructions } from './automationStudioNewSelectors';

const selectSelectedStepIds = (state) =>
    state.automationStudioNew?.selection?.selectedStepIds ?? [];

const selectStepById = createSelector([selectInstructions], (instructions) => {
    const map = new Map();
    for (const inst of instructions ?? []) {
        for (const s of inst.aiSteps ?? []) map.set(s.id, s);
    }
    return map;
});

export const selectedIdsInStepOrder = createSelector(
    [selectInstructions, selectSelectedStepIds],
    (instructions, ids) => {
        const set = new Set(ids);
        const out = [];
        for (const inst of instructions ?? []) {
            for (const s of inst.aiSteps ?? []) {
                if (set.has(s.id)) out.push(s.id);
            }
        }
        return out;
    }
);

export const canCopySelection = createSelector(
    [selectSelectedStepIds, selectStepById],
    (ids, stepById) => {
        if (!ids?.length) return false;
        for (const id of ids) {
            const step = stepById.get(id);
            if (!step || step.customStep !== true) return false;
        }
        return true;
    }
);
